import React from 'react';
import Span from '../../Texts/Span/Span';
import P from '../../Texts/P/P';
import { catchExceptionForText } from '../../../utils/Constants';
import { getValueOrDefault } from '../../../utils/Utils';

const months = {
  ...catchExceptionForText,
  '01': 'Ene',
  '02': 'Feb',
  '03': 'Mar',
  '04': 'Abr',
  '05': 'May',
  '06': 'Jun',
  '07': 'Jul',
  '08': 'Ago',
  '09': 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dic',
};

const fullMonths = {
  ...catchExceptionForText,
  '01': 'Enero',
  '02': 'Febrero',
  '03': 'Marzo',
  '04': 'Abril',
  '05': 'Mayo',
  '06': 'Junio',
  '07': 'Julio',
  '08': 'Agosto',
  '09': 'Septiembre',
  10: 'Octubre',
  11: 'Noviembre',
  12: 'Diciembre',
};

const adapterFullMonths = new Proxy(fullMonths, getValueOrDefault);
const adapterMonths = new Proxy(months, getValueOrDefault);

/*
  input: 'yyyy-MM-dd' ó 'yyyy-MM-dd ##:##:##'
  output: 'dd/MM/yyyy
*/
const fullDateFormatter = (date) => {
  let dateSplitted = date.split(/[-,' ']/);
  return dateSplitted[2] + '/' + dateSplitted[1] + '/' + dateSplitted[0];
};

/*
  input: yyyy-mm-ddT##:##:##Z
  output: dd/mm/yyyy
*/
const fullUTCDateFormatter = (date) => {
  let d = new Date(date);
  return fullDateFormatter(d.toISOString().split('T')[0]);
};

/*
  input: 'yyyy-MM-dd ##:##:##'
  output: 'dd/MM/yyyy ##:##:##'
*/
const fullDateTimeFormatter = (date) => {
  let dateTimeSplitted = date.split(' ');
  let [year, month, day] = dateTimeSplitted[0].split('-');
  let [hours, minutes] = dateTimeSplitted[1].split(':');
  return day + '/' + month + '/' + year + ' ' + hours + ':' + minutes;
};

/*
  input: ['yyyy-MM-dd', 'yyyy-MM-dd']
  output: 'dd/MM/yyyy - dd/MM/yyyy'
*/
const dateRangeFormatter = (date) => {
  let [inicialDate, endDate] = date;
  let formattedInicialDate = fullDateFormatter(inicialDate);
  let formattedEndDate = fullDateFormatter(endDate);
  return formattedInicialDate + ' - ' + formattedEndDate;
};

/*
  input: 'yyyy-MM'
  output: 'MES yyyy'
*/
const monthYearFormatter = (yearMonth) => {
  const [year, month] = yearMonth.split('-');
  return `${adapterMonths[month]} ${year}`;
};

/*
  input: 'yyyy-MM'
  output: 'MES'
*/
const monthFormatter = (yearMonth) => {
  const [, month] = yearMonth.split('-');
  return `${adapterFullMonths[month]}`;
};

/*
  input: 'yyyy-MM'
  output: 'MES'
*/
const yearFormatter = (yearMonth) => {
  const [year] = yearMonth.split('-');
  return `${year}`;
};

const dateFormatters = {
  fullDate: fullDateFormatter,
  partialDate: monthYearFormatter,
  fullDateTime: fullDateTimeFormatter,
  dateRange: dateRangeFormatter,
  fullUTCDate: fullUTCDateFormatter,
  monthDate: monthFormatter,
  yearDate: yearFormatter,
};

export const DateFormatter = ({ cell, formatExtraData }) => {
  if (cell) {
    let formattedDate = dateFormatters[formatExtraData.format](cell);
    switch (formatExtraData.format) {
      case 'fullDateTime':
        return (
          <>
            <Span variant='neutral' modifier='strong' type='4'>
              {formattedDate.split(' ')[0]}
            </Span>
            <P variant='neutral' type='5'>
              {formattedDate.split(' ')[1] + ' h'}
            </P>
          </>
        );
      default:
        return (
          <Span variant='neutral' modifier='strong' type='4'>
            {formattedDate}
          </Span>
        );
    }
  } else {
    return null;
  }
};
